export type AttackDir = "home" | "away";

// Karun Singh's published Expected Threat (xT) surface: 8 rows (width) x 12 cols
// (length). Index [row][col]; col 11 is adjacent to the attacking goal (x=120).
// Rows are symmetric about the horizontal axis. Source: karun.in/blog/expected-threat.
export const XT_GRID: number[][] = [
  [
    0.00638303, 0.00779616, 0.00844854, 0.00977659, 0.01126267, 0.01248129,
    0.01473892, 0.0174347, 0.02122129, 0.02756312, 0.03485072, 0.0379259,
  ],
  [
    0.00750072, 0.00878589, 0.00942382, 0.0105949, 0.01214719, 0.0138454,
    0.01611813, 0.01870347, 0.02401521, 0.02953272, 0.04066992, 0.04647721,
  ],
  [
    0.0088799, 0.00977745, 0.01001304, 0.01110462, 0.01269174, 0.01429128,
    0.01685596, 0.01935132, 0.0241224, 0.02855202, 0.05491138, 0.06442595,
  ],
  [
    0.00941056, 0.01082722, 0.01016549, 0.01132376, 0.01262646, 0.01484598,
    0.01689528, 0.0199707, 0.02385149, 0.03511326, 0.10805102, 0.25745362,
  ],
  [
    0.00941056, 0.01082722, 0.01016549, 0.01132376, 0.01262646, 0.01484598,
    0.01689528, 0.0199707, 0.02385149, 0.03511326, 0.10805102, 0.25745362,
  ],
  [
    0.0088799, 0.00977745, 0.01001304, 0.01110462, 0.01269174, 0.01429128,
    0.01685596, 0.01935132, 0.0241224, 0.02855202, 0.05491138, 0.06442595,
  ],
  [
    0.00750072, 0.00878589, 0.00942382, 0.0105949, 0.01214719, 0.0138454,
    0.01611813, 0.01870347, 0.02401521, 0.02953272, 0.04066992, 0.04647721,
  ],
  [
    0.00638303, 0.00779616, 0.00844854, 0.00977659, 0.01126267, 0.01248129,
    0.01473892, 0.0174347, 0.02122129, 0.02756312, 0.03485072, 0.0379259,
  ],
];

const PITCH_X = 120;
const PITCH_Y = 80;
const COLS = 12;
const ROWS = 8;

function clampIndex(v: number, max: number): number {
  if (v < 0) return 0;
  if (v > max) return max;
  return v;
}

export function zoneValue(
  location: [number, number] | undefined | null,
  dir: AttackDir,
): number {
  if (!location || location.length !== 2) return 0;
  let [x, y] = location;
  if (
    typeof x !== "number" ||
    typeof y !== "number" ||
    Number.isNaN(x) ||
    Number.isNaN(y)
  ) {
    return 0;
  }
  // Normalize so both teams attack toward x = 120.
  if (dir === "away") {
    x = PITCH_X - x;
    y = PITCH_Y - y;
  }
  const col = clampIndex(Math.floor((x / PITCH_X) * COLS), COLS - 1);
  const row = clampIndex(Math.floor((y / PITCH_Y) * ROWS), ROWS - 1);
  return XT_GRID[row][col];
}
